<template>
  <v-content>
    <v-overlay v-if="loadingOverlay === true">
      <div>Loading Page...</div>
    </v-overlay>
    <v-container>
      <v-alert :value="displayAlert" :color="alertType">{{alertMsg}}</v-alert>
      <h1 class="subheading grey--text">Profiles</h1>
      <v-row>
        <v-container>
          <v-container>
            <v-row>
              <td cols="8" sm="6" md="4">
                <v-text-field label="Instagram Profile" solo v-model="newProfile" required></v-text-field>
              </td>
              <td cols="4">
                <v-btn color="success" x-large @click="createProfile" success dark>ADD PROFILE</v-btn>
              </td>
            </v-row>
          </v-container>
        </v-container>
      </v-row>

      <v-simple-table>
        <tbody>
          <tr v-for="profile in igProfiles" :key="profile._id">
            <td>@{{profile.profileName}}</td>
            <td>
              <v-btn :to="'/engagement/candidates/'+profile.profileName" small>candidates</v-btn>
            </td>
            <td>
              <v-btn :to="'/engagement/profile/'+profile.profileName" small>edit</v-btn>
            </td>
            <td>
              <v-btn small @click="archiveProfile(profile.profileName)">archive</v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-container>
  </v-content>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import {
  igProfileListApi,
  igProfileArchiveApi,
  igProfileCreateApi
} from "@/config/appSettings";
export default {
  data: () => ({
    loadingOverlay: true,
    igProfiles: null,
    profileArchiveModal: false,
    profileAddModal: false,
    newProfile: null,
    alertType: false,
    alertMsg: null,
    alertType: null,
    displayAlert: false
  }),
  name: "EngagementProfiles",
  methods: {
    showDialog() {
      alert("HELLO WORLD");
    },
    async loadProfiles() {
      let userToken = firebase.auth().currentUser.uid;
      let loadProfilesUrl = `${igProfileListApi}${userToken}`;
      let igProfileList = await axios.get(loadProfilesUrl);

      console.log("PROFILES", igProfileList);
      if (igProfileList.data.success === true) {
        this.igProfiles = igProfileList.data.result;
      }
    },
    async createProfile() {
      try {
        let self = this;
        if (this.newProfile === null || this.newProfile === "") {
          self.alertType = "error";
          self.alertMsg = "Invalid Instagram Profile.";
          self.displayAlert = true;
          return;
        }
        let userToken = firebase.auth().currentUser.uid;
        let loadProfilesUrl = `${igProfileListApi}${userToken}`;
        let newProfile = {};
        newProfile.usertoken = userToken;
        newProfile.instagram = this.newProfile;
        newProfile.type = "engagement";

        let createIgProfileResult = await axios.post(
          igProfileCreateApi,
          newProfile
        );

        console.log("CREATE PROFILE RESULT", createIgProfileResult);
        if (createIgProfileResult.data.success === true) {
          self.alertType = "success";
          self.alertMsg = "Instagram Profile Created.";
          self.displayAlert = true;
          self.newProfile = null;
          this.loadProfiles();
        }
        if (createIgProfileResult.data.success === false) {
          self.alertType = "error";
          self.alertMsg = createIgProfileResult.data.message;
          self.displayAlert = true;
          return;
        }
      } catch (err) {
        self.alertType = "error";
        self.alertMsg = "Invalid Instagram Profile.";
        self.displayAlert = true;
        return;
      }
    },
    async archiveProfile(thisProfile) {
      try {
        let self = this;

        let userToken = firebase.auth().currentUser.uid;
        if (thisProfile === null) {
          self.alertType = "error";
          self.alertMsg = "No Profile.";
          self.displayAlert = true;
          return;
        }

        let archiveProfile = {};
        archiveProfile.usertoken = userToken;
        archiveProfile.instagram = thisProfile;

        let archiveIgProfileResult = await axios.post(
          igProfileArchiveApi,
          archiveProfile
        );
        console.log("ARCHIVE RESPONSE:", archiveIgProfileResult);
        if (archiveIgProfileResult.data.success === true) {
          self.alertType = "success";
          self.alertMsg = "Instagram Profile Archived.";
          self.displayAlert = true;
          this.loadProfiles();
          return;
        }
        if (archiveIgProfileResult.data.success === false) {
          self.alertType = "error";
          self.alertMsg = "Invalid Action.";
          self.displayAlert = true;
        }
      } catch (err) {
        self.alertType = "error";
        self.alertMsg = "Invalid Action.";
        self.displayAlert = true;
        return;
      }
    },
    closeLoadingModal() {
      let self = this;

      setTimeout(function() {
        self.loadingOverlay = false;
      }, 1000);
    }
  },
  mounted() {
    this.loadProfiles();
    this.closeLoadingModal();
  },
  watch: {}
};
</script>

<style scoped>
</style>